import repository from './repository.js';

export default {
  async getStaticData() {
    return repository
      .get('/order/dashboardCard1Static')
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((error) => {
        return { error };
      });
  },

  async getGraphData(year, demElemTypesIds, clientsIds) {
    let formData = new FormData();

    formData.append('year', year.toString());

    if (Array.isArray(demElemTypesIds)) {
      for (let index = 0; index < demElemTypesIds.length; index++) {
        formData.append(`id_dem_elem_type[${index}]`, demElemTypesIds[index]);
      }
    }

    if (Array.isArray(clientsIds)) {
      for (let index = 0; index < clientsIds.length; index++) {
        formData.append(`id_client[${index}]`, clientsIds[index]);
      }
    }

    return repository
      .post('/order/dashboardGraph', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async getDashboardCard2Data(
    startDate,
    endDate,
    demElemTypesIds,
    clientsIds,
    initiativesIds,
    regionsIds,
    directionsIds
  ) {
    let formData = new FormData();

    formData.append('date_start', startDate);
    formData.append('date_end', endDate);

    if (Array.isArray(demElemTypesIds)) {
      for (let index = 0; index < demElemTypesIds.length; index++) {
        formData.append(`id_dem_elem_type[${index}]`, demElemTypesIds[index]);
      }
    }

    if (Array.isArray(clientsIds)) {
      for (let index = 0; index < clientsIds.length; index++) {
        formData.append(`id_client[${index}]`, clientsIds[index]);
      }
    }

    if (Array.isArray(initiativesIds)) {
      for (let index = 0; index < initiativesIds.length; index++) {
        formData.append(`id_order_initiative[${index}]`, initiativesIds[index]);
      }
    }

    if (Array.isArray(regionsIds)) {
      for (let index = 0; index < regionsIds.length; index++) {
        formData.append(`id_region[${index}]`, regionsIds[index]);
      }
    }

    if (Array.isArray(directionsIds)) {
      for (let index = 0; index < directionsIds.length; index++) {
        formData.append(`id_direction[${index}]`, directionsIds[index]);
      }
    }

    return repository
      .post('/order/dashboardCard2', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async getDashboardCard2DataPieCharts(
    startDate,
    endDate,
    demElemTypesIds,
    usersIds,
    storageTypesIds,
    clientsIds,
    initiativesIds,
    regionsIds,
    directionsIds
  ) {
    let formData = new FormData();

    formData.append('date_start', startDate);
    formData.append('date_end', endDate);

    if (Array.isArray(demElemTypesIds)) {
      for (let index = 0; index < demElemTypesIds.length; index++) {
        formData.append(`id_dem_elem_type[${index}]`, demElemTypesIds[index]);
      }
    }

    if (Array.isArray(usersIds)) {
      for (let index = 0; index < usersIds.length; index++) {
        formData.append(`id_user[${index}]`, usersIds[index]);
      }
    }

    if (Array.isArray(storageTypesIds)) {
      for (let index = 0; index < storageTypesIds.length; index++) {
        formData.append(`id_storage_type[${index}]`, storageTypesIds[index]);
      }
    }

    if (Array.isArray(clientsIds)) {
      for (let index = 0; index < clientsIds.length; index++) {
        formData.append(`id_client[${index}]`, clientsIds[index]);
      }
    }

    if (Array.isArray(initiativesIds)) {
      for (let index = 0; index < initiativesIds.length; index++) {
        formData.append(`id_order_initiative[${index}]`, initiativesIds[index]);
      }
    }

    if (Array.isArray(regionsIds)) {
      for (let index = 0; index < regionsIds.length; index++) {
        formData.append(`id_region[${index}]`, regionsIds[index]);
      }
    }

    if (Array.isArray(directionsIds)) {
      for (let index = 0; index < directionsIds.length; index++) {
        formData.append(`id_direction[${index}]`, directionsIds[index]);
      }
    }

    return repository
      .post('/order/dashboard2CardGraphs', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async getDashboardCard3DataMonths(
    year,
    demElemTypesIds,
    orderRangesIds,
    clientsIds,
    initiativesIds,
    regionsIds,
    directionsIds
  ) {
    let formData = new FormData();

    formData.append('year', year.toString());

    if (Array.isArray(demElemTypesIds)) {
      for (let index = 0; index < demElemTypesIds.length; index++) {
        formData.append(`id_dem_elem_type[${index}]`, demElemTypesIds[index]);
      }
    }

    if (Array.isArray(orderRangesIds)) {
      for (let index = 0; index < orderRangesIds.length; index++) {
        formData.append(`id_order_range[${index}]`, orderRangesIds[index]);
      }
    }

    if (Array.isArray(clientsIds)) {
      for (let index = 0; index < clientsIds.length; index++) {
        formData.append(`id_client[${index}]`, clientsIds[index]);
      }
    }

    if (Array.isArray(initiativesIds)) {
      for (let index = 0; index < initiativesIds.length; index++) {
        formData.append(`id_order_initiative[${index}]`, initiativesIds[index]);
      }
    }

    if (Array.isArray(regionsIds)) {
      for (let index = 0; index < regionsIds.length; index++) {
        formData.append(`id_region[${index}]`, regionsIds[index]);
      }
    }

    if (Array.isArray(directionsIds)) {
      for (let index = 0; index < directionsIds.length; index++) {
        formData.append(`id_direction[${index}]`, directionsIds[index]);
      }
    }

    return repository
      .post('/order/dashboardCard3Collisions', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  },

  async getDashboardCard3DataOtherTables(startDate, endDate, orderRangesIds, clientsIds) {
    let formData = new FormData();

    formData.append('date_start', startDate);
    formData.append('date_end', endDate);

    if (Array.isArray(orderRangesIds)) {
      for (let index = 0; index < orderRangesIds.length; index++) {
        formData.append(`id_order_range[${index}]`, orderRangesIds[index]);
      }
    }

    if (Array.isArray(clientsIds)) {
      for (let index = 0; index < clientsIds.length; index++) {
        formData.append(`id_client[${index}]`, clientsIds[index]);
      }
    }

    return repository
      .post('/order/dashboardCard3Ranges', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        if (response.data.error == null) return response.data;
      })
      .catch((serverError) => {
        return { serverError };
      });
  }
};
